import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { Authorities } from '../enums/authorities.enum';

@Injectable({ providedIn: 'root' })
export class AccessService {
  private readonly authService = inject(AuthService);

  // GLOBAL
  canCreateNewEntity(): boolean {
    return this.authService.hasAnyAuthority([
      Authorities.BULK_ITEMS_MANAGE,
      Authorities.CONTACT_MANAGE,
      Authorities.EMPLOYEE_MANAGE,
      Authorities.EQUIPMENT_CREATE,
      Authorities.PROJECT_CREATE,
      Authorities.STOCK_MANAGE,
      Authorities.TRANSPORT_TASK_MANAGE,
      Authorities.TRANSPORT_TASK_DISPOSITION,
    ]);
  }

  // EQUIPMENT
  canCreateEquipment(): boolean {
    return this.authService.hasAuthority(Authorities.EQUIPMENT_CREATE);
  }
}
